import React from "react";

const Gallery = ({ style }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      style={style}
      stroke="currentColor"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rettangolo_295"
            width="31"
            height="27"
            transform="translate(-0.295)"
          />
        </clipPath>
      </defs>
      <g id="Raggruppa_573" transform="translate(-1539 -294)">
        <g
          id="Raggruppa_572"
          transform="translate(1540.295 297)"
          clipPath="url(#clip-path)"
        >
          <path
            id="Tracciato_132"
            d="M29.652,21.838a2.6,2.6,0,0,1-2.6,2.6H3.6a2.6,2.6,0,0,1-2.6-2.6V7.512a2.6,2.6,0,0,1,2.6-2.6h5.21L11.419,1h7.814l2.6,3.907h5.21a2.6,2.6,0,0,1,2.6,2.6Z"
            transform="translate(-0.249 0.302)"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
          <circle
            id="Ellisse_32"
            cx="5.5"
            cy="5.5"
            r="5.5"
            transform="translate(9.705 9)"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
        </g>
      </g>
    </svg>
  );
};

export default Gallery;
